import { gql } from '@apollo/client';

export const EscrowAgreementFields = gql`
  fragment EscrowAgreementFields on Agreement {
    agreementForm
    id
    jurisdiction
    liability
    approvedByBeneficiary
    approvedByCodekeeper
    approvedByDepositor
    thirdPartyAgreement
    updatedAt
    legalContext
    legalContextOther
    policy {
      approve
      generate
      write
      download
    }
    approved
    conditions
    conditionsOther
  }
`;
